module.exports = __webpack_public_path__ + "static/img/areaA-3.1878284.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-3.png
// module id = 941
// module chunks = 1